import { Component } from '@angular/core';

@Component({
    selector: 'app-page',
    templateUrl: './app-page.component.html',
    styleUrls: ['./app-page.component.scss'],
})
export class AppPageComponent {}
